function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { AdvertsManagerState } from '../../../addons/adverts-manager-stages/adverts-initialisation-stage-manager';
import { sdkLogger } from '../../../logger';
import { createLoggingObservable } from '../../../utils/observables/verbose-logging-observable';
import { VideoStartupEngineStarter } from './video-startup-engine-starter';
import { StreamQuality } from '../../player/playout-data';
import { SessionRestartType, SessionRestartController } from '../restart/session-restart-controller';
import { VideoProviderController } from '../video-provider/video-provider-controller';
import { UninitialisedState, VideoStartupStates } from './video-startup-states';
import { VideoFormat } from '../../player/player.enums';
var _obj;
var SDK_STREAM_QUALITY_TO_VIDEO_FORMAT = (_obj = {}, _define_property(_obj, StreamQuality.SD, VideoFormat.SD), _define_property(_obj, StreamQuality.HD, VideoFormat.HD), _define_property(_obj, StreamQuality.UHD, VideoFormat.UHD), _obj);
export var VideoStartupController = /*#__PURE__*/ function() {
    "use strict";
    function VideoStartupController(advertsManager, videoStartupEngineStarterOptions) {
        var _this = this;
        _class_call_check(this, VideoStartupController);
        _define_property(this, "advertsManager", void 0);
        _define_property(this, "videoStartupEngineStarterOptions", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "telemetryUpdateObservable", void 0);
        _define_property(this, "_shouldSkipAdvertisements", void 0);
        _define_property(this, "_state", void 0);
        _define_property(this, "_cachedModifiedPlayoutData", void 0);
        _define_property(this, "_cachedOvpOriginalPlayoutData", void 0);
        _define_property(this, "videoProviderController", void 0);
        _define_property(this, "restartController", void 0);
        _define_property(this, "restartSessionOverrides", void 0);
        _define_property(this, "sessionControllerInternal", void 0);
        _define_property(this, "_engineStarter", void 0);
        _define_property(this, "handleRobustnessFailover", void 0);
        _define_property(this, "updateState", void 0);
        this.advertsManager = advertsManager;
        this.videoStartupEngineStarterOptions = videoStartupEngineStarterOptions;
        this.logger = sdkLogger.withContext('VideoStartupController');
        this.telemetryUpdateObservable = createLoggingObservable('TelemetryDataType', this.logger);
        this._shouldSkipAdvertisements = false;
        this._state = new UninitialisedState(VideoStartupStates.Uninitialised);
        this._cachedModifiedPlayoutData = null;
        this._cachedOvpOriginalPlayoutData = null;
        this.restartSessionOverrides = null;
        this.handleRobustnessFailover = function(robustnessFailover) {
            if (!_this._cachedModifiedPlayoutData) {
                _this.logger.warn('Robustness failover occurred but no playout data is available to read');
                return;
            }
            var playbackType = _this._cachedModifiedPlayoutData.type;
            if (!VideoStartupController.globalMaxVideoFormat.get(playbackType)) {
                // No robustness errors have occurred, store the current max video format for the given playback type
                VideoStartupController.globalMaxVideoFormat.set(playbackType, robustnessFailover.maxVideoFormat);
            }
            VideoStartupController.globalMaxVideoFormat.set(playbackType, robustnessFailover.maxVideoFormat);
        };
        this.updateState = function(updateState) {
            try {
                _this._state = updateState();
                _this.logCurrentState();
            } catch (error) {
                _this.logger.error(error);
            }
        };
        this.advertsManager = advertsManager;
        this.videoProviderController = new VideoProviderController();
        this.logCurrentState();
    }
    _create_class(VideoStartupController, [
        {
            key: "state",
            get: function get() {
                return this._state;
            }
        },
        {
            key: "shouldSkipAdvertisements",
            get: function get() {
                return this._shouldSkipAdvertisements;
            }
        },
        {
            key: "cachedModifiedPlayoutData",
            get: function get() {
                return this._cachedModifiedPlayoutData;
            }
        },
        {
            key: "cachedOvpOriginalPlayoutData",
            get: function get() {
                return this._cachedOvpOriginalPlayoutData;
            }
        },
        {
            key: "isDestroyed",
            get: function get() {
                return this.state.type() === VideoStartupStates.Destroyed;
            }
        },
        {
            key: "engineStarter",
            get: function get() {
                return this._engineStarter;
            }
        },
        {
            key: "onTelemetryUpdate",
            value: function onTelemetryUpdate(callback) {
                this.telemetryUpdateObservable.registerObserver(callback, this);
            }
        },
        {
            key: "notifyTelemetryUpdate",
            value: function notifyTelemetryUpdate() {
                var _this = this;
                var telemetryData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                if (telemetryData.length > 0) {
                    telemetryData.forEach(function(t) {
                        return _this.telemetryUpdateObservable.notifyObservers(t);
                    });
                }
            }
        },
        {
            key: "setSessionControllerInternal",
            value: function setSessionControllerInternal(sessionControllerInternal) {
                this.sessionControllerInternal = sessionControllerInternal;
            }
        },
        {
            key: "startSession",
            value: function startSession() {
                if (this.restartController) {
                    this.restartController.startSession();
                } else {
                    this.sessionControllerInternal.start();
                }
            }
        },
        {
            key: "createRestartController",
            value: function createRestartController(sessionProxy, sessionItem, sessionControllerInternalFactory) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        if (_this.restartController) {
                            return [
                                2
                            ];
                        }
                        _this.restartController = new SessionRestartController(sessionControllerInternalFactory, sessionProxy, sessionItem);
                        _this.restartController.onRobustnessFailover(_this.handleRobustnessFailover);
                        _this.restartController.initialise();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "onRestartSessionInitiatedHandler",
            value: function onRestartSessionInitiatedHandler(callback) {
                var _this = this;
                var handler = function(restartOptions) {
                    var modifiedRestartOptions = callback(restartOptions);
                    _this.restartSessionOverrides = modifiedRestartOptions;
                    _this.handleRestartInitiated();
                };
                this.restartController.onRestartSessionInitiated(handler);
            }
        },
        {
            key: "setAdvertsManager",
            value: function setAdvertsManager(advertsManager) {
                this.advertsManager = advertsManager;
            }
        },
        {
            key: "setShouldSkipAdvertisements",
            value: function setShouldSkipAdvertisements() {
                this._shouldSkipAdvertisements = true;
            }
        },
        {
            key: "setCachedModifiedPlayoutData",
            value: function setCachedModifiedPlayoutData(playoutData) {
                this._cachedModifiedPlayoutData = playoutData;
            }
        },
        {
            key: "setCachedOriginalPlayoutData",
            value: function setCachedOriginalPlayoutData(playoutData) {
                this._cachedOvpOriginalPlayoutData = playoutData;
            }
        },
        {
            key: "initialise",
            value: function initialise() {
                this.updateState(this._state.initialise);
            }
        },
        {
            key: "callVideoProvider",
            value: function callVideoProvider(sessionItem, videoPlatformIntegration, isPrefetch) {
                var _this = this;
                return _async_to_generator(function() {
                    var globalMaxVideoFormat, _sessionItem_videoFormatConfig_support, _sessionItem_videoFormatConfig, _sessionItem_videoFormatConfig1, _sessionItem_videoFormatConfig_support1, // TODO: for CDN switch purposes (to investigate we might need to check if the original playout data is already set - CDN switch? - if so we don't get it again)
                    modifiedPlayoutData, streamVideoFormat;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                globalMaxVideoFormat = VideoStartupController.globalMaxVideoFormat.get(sessionItem.type);
                                if (typeof globalMaxVideoFormat !== 'undefined') {
                                    ;
                                    if (typeof (sessionItem === null || sessionItem === void 0 ? void 0 : (_sessionItem_videoFormatConfig = sessionItem.videoFormatConfig) === null || _sessionItem_videoFormatConfig === void 0 ? void 0 : (_sessionItem_videoFormatConfig_support = _sessionItem_videoFormatConfig.support) === null || _sessionItem_videoFormatConfig_support === void 0 ? void 0 : _sessionItem_videoFormatConfig_support.maxVideoFormat) !== 'undefined') {
                                        // Reduce max video format the session item supports if it is greater than the global max video format
                                        sessionItem.videoFormatConfig.support.maxVideoFormat = Math.min(globalMaxVideoFormat, sessionItem.videoFormatConfig.support.maxVideoFormat);
                                    } else if (typeof globalMaxVideoFormat !== 'undefined') {
                                        ;
                                        // No max video format set on the session item, set it to the global max video format when available
                                        sessionItem.videoFormatConfig = (_sessionItem_videoFormatConfig1 = sessionItem.videoFormatConfig) !== null && _sessionItem_videoFormatConfig1 !== void 0 ? _sessionItem_videoFormatConfig1 : {};
                                        ;
                                        sessionItem.videoFormatConfig.support = (_sessionItem_videoFormatConfig_support1 = sessionItem.videoFormatConfig.support) !== null && _sessionItem_videoFormatConfig_support1 !== void 0 ? _sessionItem_videoFormatConfig_support1 : {};
                                        sessionItem.videoFormatConfig.support.maxVideoFormat = globalMaxVideoFormat;
                                    }
                                }
                                return [
                                    4,
                                    _this.videoProviderController.fetchPlayoutData(sessionItem, videoPlatformIntegration, _this.restartSessionOverrides, isPrefetch)
                                ];
                            case 1:
                                modifiedPlayoutData = _state.sent();
                                if (modifiedPlayoutData.stream.quality) {
                                    streamVideoFormat = SDK_STREAM_QUALITY_TO_VIDEO_FORMAT[modifiedPlayoutData.stream.quality];
                                    if (typeof globalMaxVideoFormat !== 'undefined' && globalMaxVideoFormat > streamVideoFormat) {
                                        // Assume a server-side downgrade occurred and gracefully update the global max video format
                                        VideoStartupController.globalMaxVideoFormat.set(sessionItem.type, streamVideoFormat);
                                    }
                                }
                                if (_this.isDestroyed) {
                                    _this.logger.info("Video Startup is destroyed, aborting last action");
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                _this.notifyTelemetryUpdate(_this.getVideoProviderControllerTelemetryData());
                                _this.setCachedOriginalPlayoutData(modifiedPlayoutData);
                                _this.setCachedModifiedPlayoutData(modifiedPlayoutData);
                                _this.updateState(_this._state.callVideoProvider);
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getVideoProviderControllerTelemetryData",
            value: function getVideoProviderControllerTelemetryData() {
                return this.videoProviderController.getTelemetryData();
            }
        },
        {
            key: "skipAdvertisement",
            value: function skipAdvertisement() {
                this.setShouldSkipAdvertisements();
                this.updateState(this._state.skipAdvertisement);
            }
        },
        {
            key: "initialiseAdverts",
            value: function initialiseAdverts(sessionItem) {
                var modifiedPlayoutData = this.advertsManager.initialise(sessionItem, this.cachedModifiedPlayoutData);
                this.setCachedModifiedPlayoutData(modifiedPlayoutData);
                this.updateState(this._state.initialiseAdverts);
                if (this.advertsManager.getAdvertisementInitialisationStatus() === AdvertsManagerState.Disabled) {
                    this.skipAdvertisement();
                }
            }
        },
        {
            key: "callVam",
            value: function callVam(sessionItem, context) {
                var _this = this;
                return _async_to_generator(function() {
                    var modifiedPlayoutData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.advertsManager.fetchVamData(sessionItem, _this.cachedOvpOriginalPlayoutData, context)
                                ];
                            case 1:
                                modifiedPlayoutData = _state.sent();
                                if (_this.isDestroyed) {
                                    _this.logger.info("Video Startup is destroyed, aborting last action");
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                _this.setCachedModifiedPlayoutData(modifiedPlayoutData);
                                _this.updateState(_this._state.callVam);
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "bootstrapAds",
            value: function bootstrapAds() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.advertsManager.bootstrapAds(_this.cachedModifiedPlayoutData)
                                ];
                            case 1:
                                _state.sent();
                                _this.updateState(_this._state.bootstrapAds);
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "callAdsData",
            value: function callAdsData() {
                var _this = this;
                return _async_to_generator(function() {
                    var modifiedPlayoutData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.advertsManager.fetchAdvertisementData(_this.cachedModifiedPlayoutData, _this.cachedOvpOriginalPlayoutData)
                                ];
                            case 1:
                                modifiedPlayoutData = _state.sent();
                                if (_this.isDestroyed) {
                                    _this.logger.info("Video Startup is destroyed, aborting last action");
                                    return [
                                        2,
                                        false
                                    ];
                                }
                                _this.setCachedModifiedPlayoutData(modifiedPlayoutData);
                                _this.updateState(_this._state.callAdsData);
                                return [
                                    2,
                                    true
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createEngineStarter",
            value: function createEngineStarter(sessionItem) {
                this._engineStarter = new VideoStartupEngineStarter(sessionItem, this.videoStartupEngineStarterOptions);
            }
        },
        {
            key: "startEngine",
            value: function startEngine(sessionItem, context) {
                var _this = this;
                return _async_to_generator(function() {
                    var modifiedPlayoutData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.engineStarter) {
                                    _this.createEngineStarter(sessionItem);
                                }
                                return [
                                    4,
                                    _this._engineStarter.startEngine(_this.cachedModifiedPlayoutData, context === null || context === void 0 ? void 0 : context.isPrefetch)
                                ];
                            case 1:
                                modifiedPlayoutData = _state.sent();
                                if (_this.state.type() === VideoStartupStates.Discarded) {
                                    // There was a failure during engine start
                                    return [
                                        2
                                    ];
                                }
                                if (!modifiedPlayoutData) {
                                    return [
                                        2
                                    ];
                                }
                                _this.setCachedModifiedPlayoutData(modifiedPlayoutData);
                                _this.updateState(_this._state.startEngine);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "destroyVideoStartupEntities",
            value: /**
     * Destroy entities that have the same lifecycle as an internal session
     */ function destroyVideoStartupEntities() {
                var _this_engineStarter;
                this.telemetryUpdateObservable.unregisterObservers(this);
                (_this_engineStarter = this.engineStarter) === null || _this_engineStarter === void 0 ? void 0 : _this_engineStarter.destroy();
                this._cachedModifiedPlayoutData = null;
                this._cachedOvpOriginalPlayoutData = null;
                this._shouldSkipAdvertisements = false;
                this.sessionControllerInternal = undefined;
            }
        },
        {
            key: "destroyUserSessionEntities",
            value: /**
     * Destroy entities that have the same lifecycle as the public facing session
     */ function destroyUserSessionEntities() {
                var _this_restartController;
                (_this_restartController = this.restartController) === null || _this_restartController === void 0 ? void 0 : _this_restartController.destroy();
            }
        },
        {
            key: "discard",
            value: function discard() {
                this.destroyVideoStartupEntities();
                this.destroyUserSessionEntities();
                this.updateState(this._state.discard);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.destroyVideoStartupEntities();
                this.destroyUserSessionEntities();
                this.updateState(this._state.destroy);
            }
        },
        {
            key: "logCurrentState",
            value: function logCurrentState() {
                this.logger.verbose("Video Startup Stage set to: ".concat(this._state));
            }
        },
        {
            key: "handleRestartInitiated",
            value: function handleRestartInitiated() {
                this.destroyVideoStartupEntities();
                this.updateState(this._state.retry);
            }
        },
        {
            key: "isRestarting",
            value: function isRestarting() {
                var _this_restartController;
                return Boolean((_this_restartController = this.restartController) === null || _this_restartController === void 0 ? void 0 : _this_restartController.isRestarting());
            }
        },
        {
            key: "restart",
            value: function restart() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.restartController.isRestarting()) {
                                    _this.logger.info("Attempting ".concat(SessionRestartType.RESTART, " on Retry Controller while it is already restarting"));
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this.restartController.restart(SessionRestartType.RESTART)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return VideoStartupController;
}();
/** When defined, overrides the max video format for the remainder of the life of CVSDK for a given stream type */ _define_property(VideoStartupController, "globalMaxVideoFormat", new Map());

//# sourceMappingURL=video-startup-controller.js.map